/*
 * View for Engines
 */

define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbLocales/template/kbLocalesTemplate.html",
], function (Marionette, KbLocalesTemplate) {
  var KbLocaleModalView = {};

  KbLocaleModalView.kbLocalesLayout = Marionette.Layout.extend({
    template: KbLocalesTemplate,
    regions: {
      list: "#kbLocaleList",
      languageAvailableSearch: "#kbLanguageAvailableSearch",
      responseTypeUsage: "#responseTypeUsage",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #kbEditLocaleAdd": "addLocaleToKb",
    },

    getLocaleToAdd: function () {
      return parseInt(this.$el.find("#availableLanguagesToAdd").val());
    },

    languageAddError: function (errorMessage) {
      this.$el
        .find("#kbLocaleEditAddLanguageError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },

    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
  });

  return KbLocaleModalView;
});
